export default __webpack_public_path__ + "static/media/metamask.a756aeb9.png";